import styled from 'styled-components';

const PdfContainer = styled.div`
  width: 280px;
  height: 470px;
  overflow: hidden;
`;

export default { PdfContainer };
